<template >
  <div class="autocomplete">
    <!-- <div class="autocomplete__box" :class="[inputClass, {'autocomplete__searching' : showResults}]"> -->
      <div  :class="[
                inputClass,
                {
                  'autocomplete__searching': showResults,
                  'autocomplete__boxrequired': inputClassRequired && !value,
                  'autocomplete__valid': inputClassRequired && !!value,
                  'autocomplete__box': !inputClassRequired,
                  'autocomplete__disabled': disableInput,
                  'autocomplete__enabled': !disableInput
                }
              ]">

                    

      <img v-if="!isLoading  && !disableInput" class="autocomplete__icon" v-bind:src="'../../../static/img/search.svg'">
      <img v-if="isLoading" class="autocomplete__icon animate-spin" v-bind:src="'../../../static/img/loading.svg'">
      <div class="autocomplete__inputs">
        <input
          v-model="display"
          type="text"
          :placeholder="placeholder"
          :disabled="disableInput"
          @click="search"
          @input="search"
          @keydown.prevent.enter="enter"
          @keydown.tab="close"
          @keydown.up="up"
          @keydown.down="down"
          @keydown.esc="close"
          @focus="focus"
          @blur="blur"
          ref="autocomplete">
        <input :name="name" type="hidden" :value="value">

      </div>

      <img v-show="!disableInput && !isEmpty && !isLoading && !hasError" class="autocomplete__icon autocomplete--clear" @click="clear" v-bind:src="'../../../static/img/close.svg'">
    </div>

    <ul v-show="showResults" class="autocomplete__results" :style="listStyle">

      <slot name="results">
        <!-- error -->
        <li v-if="hasError" class="autocomplete__results__item autocomplete__results__item--error">{{ error }}</li>

        <!-- results -->
        <li v-if="!hasError"
            v-for="(result, key) in results"
            @click.prevent="select(result)"
            class="autocomplete__results__item"
            :class="{'autocomplete__selected' : isSelected(key) }">
          {{ displayProperty(result) }}
        </li>

        <!-- no results -->
        <li v-if="noResults && !isLoading && isFocussed && !hasError" class="autocomplete__results__item autocomplete__no-results">Não encontrado.</li>
      </slot>
    </ul>
  </div>
</template>

<script type="text/babel">
import debounce from 'lodash/debounce'
export default {
  props: {
    /**
     * Data source for the results
     * @type {String|Object}
     */
    source: {
      type: [Object, Array, String],
      required: true
    },
    /**
     * Input placeholder
     * @type {String}
     */
    placeholder: {
      default: 'Search'
    },
    /**
     * Preset starting value
     * @type {String|Number}
     */
    initialValue: {
      type: [String, Number]
    },
    /**
     * Preset starting display value
     * @type {String}
     */
    initialDisplay: {
      type: String
    },
    /**
     * CSS class for the surrounding input div
     * @type {String|Object}
     */
    inputClass: {
      type: [String, Object]
    },
    /**
     * To disable the input
     * @type {Boolean}
     */
    inputClassRequired: {
      type: Boolean
    },
    /**
     * To disable the input
     * @type {Boolean}
     */
    disableInput: {
      type: Boolean
    },
    /**
     * name property of the input holding the selected value
     * @type {String}
     */
    name: {
      type: String
    },
    /**
     * api - property of results array
     * @type {String}
     */
    resultsProperty: {
      type: String
    },
    /**
     * Results property used as the value
     * @type {String}
     */
    resultsValue: {
      type: String,
      default: 'id'
    },
    /**
     * Results property used as the display
     * @type {String}
     */
    resultsDisplay: {
      type: [String, Function],
      default: 'name'
    },

    /**
     * Additional request headers
     * @type {Object}
     */
    requestHeaders: {
      type: Object
    }
  },
  data () {
    return {
      value: null,
      display: null,
      results: null,
      selectedIndex: 0,
      loading: false,
      isFocussed: false,
      error: null,
      selectedId: null,
      selectedDisplay: null,
      eventListener: false
    }
  },
  computed: {
    showResults () {
      return Array.isArray(this.results) || this.hasError
    },
    noResults () {
      return Array.isArray(this.results) && this.results.length === 0
    },
    isEmpty () {
      return !this.display
    },
    isLoading () {
      return this.loading === true
    },
    hasError () {
      return this.error !== null
    },
    listStyle () {
      if (this.isLoading) {
        return {
          color: '#ccc'
        }
      }
    }
  },
  methods: {
    getResultsValue() {
      // Retorna o valor de `value` ou qualquer outro valor do componente pai
      return this.value
    },
    focus () {
      this.isFocussed = true
    },
    blur () {
      this.isFocussed = false
    },
    isSelected (key) {
      return key === this.selectedIndex
    },
    search () {
      switch (typeof this.source) {
        case 'string':
          // No resource search with no input
          if (!this.display || this.display.length < 1) {
            return
          }
          this.loading = true
          this.resourceSearch()
          break
        case 'object':
          this.loading = true
          this.objectSearch()
          break
        default:
          throw new TypeError()
      }
    },

    resourceSearch: debounce(function () {
      if (!this.display) {
        this.results = []
        this.loading = false
        return
      }
      let promise = this.$http.get(this.source + this.display)
      this.setEventListener()
      promise.then((data) => {
        this.results = this.setResults(data.data)
        if (this.results.length === 0) {
          this.$emit('noResults', {query: this.display})
        } else {
          this.$emit('results', {results: this.results})
        }
        this.loading = false
      }).catch(error => {
        //this.error = error.message
        this.error = 'Sistema não conectado!'
        this.loading = false
        
      })
    }, 200),

    /**
     * Set results property from api response
     * @param {Object|Array} response
     * @return {Array}
     */
    setResults (response) {
      if (this.resultsProperty && response[this.resultsProperty]) {
        return response[this.resultsProperty]
      }
      if (Array.isArray(response)) {
        return response
      }
      return []
    },

    objectSearch () {
      this.setEventListener()

      if (!this.display) {
        this.results = this.source
        this.$emit('results', {results: this.results})
        this.loading = false
        return true
      }

      this.results = this.source.filter((item) => {
        return this.displayProperty(item).toLowerCase().includes(this.display.toLowerCase())
      })
      // not v.dry :(
      this.$emit('results', {results: this.results})
      this.loading = false
    },

    select (obj) {
      if (!obj) {
        return
      }

      this.setValues(obj)

      this.$emit('selected', {
        value: this.value,
        display: this.display,
        selectedObject: obj
      })

      this.$emit('input', this.value)

      this.close()
    },

    setValues (obj) {
      this.value = (this.resultsValue && obj[this.resultsValue]) ? obj[this.resultsValue] : obj.id
      this.display = this.displayProperty(obj)
      this.selectedDisplay = this.display
    },

    /**
     * @param  {Object} obj
     * @return {String}
     */
    displayProperty (obj) {
      return typeof this.resultsDisplay === 'function'
        ? this.resultsDisplay(obj)
        : obj[this.resultsDisplay] ? obj[this.resultsDisplay] : obj.name
    },

    up () {
      this.selectedIndex = (this.selectedIndex === 0) ? this.results.length - 1 : this.selectedIndex - 1
    },
    down () {
      this.selectedIndex = (this.selectedIndex === this.results.length - 1) ? 0 : this.selectedIndex + 1
    },
    enter () {
      this.select(this.results[this.selectedIndex])
    },
    clear () {
      this.clearValues()
      this.results = null
      this.error = null
      this.$emit('clear')
    },
    clearValues () {
      this.display = null
      this.value = null
    },
    close () {
      if (!this.value || !this.selectedDisplay) {
        this.clear()
      }
      if (this.selectedDisplay !== this.display && this.value) {
        this.display = this.selectedDisplay
      }

      this.results = null
      this.error = null
      this.removeEventListener()
      this.$emit('close')
    },
    setEventListener () {
      if (this.eventListener) {
        return false
      }
      this.eventListener = true
      document.addEventListener('click', this.clickOutsideListener, true)
      return true
    },
    removeEventListener () {
      this.eventListener = false
      document.removeEventListener('click', this.clickOutsideListener, true)
    },
    clickOutsideListener (event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.close()
      }
    }
  },
  mounted () {
    this.value = this.initialValue
    this.display = this.initialDisplay
    this.selectedDisplay = this.initialDisplay
  },
  watch: {
    value(newIndex) {
      this.$emit('indexChanged', newIndex);
    }
  }
}
/*
.autocomplete{
  position: relative;
  width: 80%;
}
*/
</script>

<style>
.autocomplete{
    position: relative;
    width: 1%;
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: 0;
    
}
.autocomplete * {
    box-sizing: border-box;
    
}
.autocomplete__enabled {
     background: #fff !important;
}  
.autocomplete__disabled {
     background: #c2cfd6 !important;
     opacity: 1 !important; 
}
.autocomplete__box{
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 0px;
  padding: 0.35rem 0.75rem;
}
.autocomplete__boxrequired{
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 0px;
  /* padding: 0.35rem 0.75rem; */
  padding: 0.35rem 0.75rem;
  border-color: #f86c6b;
}
.autocomplete__valid {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #28a745 !important; /* verde Bootstrap */
  border-radius: 0px;
  padding: 0.35rem 0.75rem;
}



.autocomplete__searching{
  border-radius: 0px 0px 0 0;
}

.autocomplete__inputs {
  flex-grow: 1;
  padding: 0 5px;
}

.autocomplete__inputs input {
    width: 100%;
    border: 0 !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    outline: none !important;
    background: transparent;
    color: #3e5150;
}
.autocomplete__inputs input:disabled {
     background-color: #c2cfd6;
     opacity: 1;
}
.autocomplete__inputs input:focus,
.autocomplete__inputs input.focus{
   outline: none !important;
   box-shadow: none !important;
   color: #3e5150;
   -webkit-box-shadow: none !important;
}
.autocomplete--clear{
  cursor: pointer;
}

.autocomplete__results {
  margin: 0;
  padding: 0;
  list-style-type: none;
  z-index: 1000;
  position: absolute;
  max-height: 400px;
  overflow-y: auto;
  background: white;
  width: 100%;
  border: 1px solid #ccc;
  border-top: 0;
  color: black;
}

.autocomplete__results__item--error{
  color: red;
}

.autocomplete__results__item{
  padding: 7px 10px;
}
.autocomplete__results__item.hover{
    background: rgba(0, 180, 255, 0.075);
}
.autocomplete__results__item.autocomplete__selected{
   background: rgba(0, 180, 255, 0.15);
}

.autocomplete__icon{
  height: 14px;
  width: 14px;
}

.animate-spin{
  animation: spin 2s infinite linear;
}


@keyframes spin {
  from { transform: rotate(0deg);}
  to { transform: rotate(360deg); }
}
</style>




// WEBPACK FOOTER //
// src/views/componentes/Autocomplete.vue